<div class="ui-g">
  <div class="ui-g-4">
    <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
  </div>
  <div class="ui-g-2">
    <label class="total-number">{{ totalByCriteria(collection, 'male') }}</label>
  </div>
  <div class="ui-g-2">
    <label class="total-number">{{ totalByCriteria(collection, 'female') }}</label>
  </div>
  <div class="ui-g-2">
    <label class="total-number">{{ totalByCriteria(collection, 'other') }}</label>
  </div>
  <div class="ui-g-2">
    <label class="total-number">{{ totalByCriteria(collection, 'total') }}</label>
  </div>
</div>
